export default function slideDown(el, duration = 400, updateTabIndex = false, addAriaHidden = false) {
	if (!el) {
		return;
	}

	el.style.display = '';
	el.style.overflow = 'hidden';
	el.style.height = 0;
	el.style.paddingTop = 0;
	el.style.paddingBottom = 0;
	el.style.marginTop = 0;
	el.style.marginBottom = 0;
	el.scrollHeight;

	el.style.transitionProperty = 'height, margin, padding';
	el.style.transitionDuration = `${duration}ms`;
	el.style.transitionTimingFunction = 'ease-in-out';
	el.style.height = `${el.scrollHeight}px`;

	el.style.removeProperty('padding-top');
	el.style.removeProperty('padding-bottom');
	el.style.removeProperty('margin-top');
	el.style.removeProperty('margin-bottom');

	if (updateTabIndex) {
		el.setAttribute('tabindex', '-1');
	}
	if (addAriaHidden) {
		el.setAttribute('aria-hidden', false);
	}

	window.setTimeout(function() {
		el.style.removeProperty('height');
		el.style.removeProperty('overflow');
		el.style.removeProperty('transition-duration');
		el.style.removeProperty('transition-property');
		el.style.removeProperty('transition-timing-function');
	}, duration);
}
